import classNames from 'classnames'
import { graphql, useStaticQuery } from 'gatsby'
import Img from 'gatsby-image'
import PropTypes from 'prop-types'
import React from 'react'

import ImageModel from '../../datas/models/Image'
import { chainDecorators, memoized } from '../../utils/ReactUtils'
import { isString } from '../../utils/StringUtils'

// /!\ To test gatby-image integration in storybook :
// query all images in src/images and get one image with
// img props when is a string (ex: 'article.png')

const decorators = [
  memoized,
]

function ImageGatsby(props) {
  const { src, className, loading } = props

  const data = useStaticQuery(graphql`
    query {
      allImageSharp {
        edges {
          node {
            fluid(maxWidth: 350) {
              ...GatsbyImageSharpFluid
              originalName
            }
          }
        }
      }
    }
  `)

  if (isString(src)) {
    const image = src
      ? data.allImageSharp.edges.find(edge => edge.node.fluid.originalName === src)
      : null

    return image ? (
      <Img
        fluid={image.node.fluid}
        className={classNames('image', className)}
        loading={loading}
        placeholderStyle={{ visibility: "hidden" }}
      />
    ) : null
  }
  return (
    <Img
      fluid={src}
      className={classNames('image', className)}
      loading={loading}
      placeholderStyle={{ visibility: "hidden" }}
    />
  )
}

ImageGatsby.propTypes = {
  className: PropTypes.string,
  src: PropTypes.oneOfType([PropTypes.string, ImageModel.propTypes]).isRequired,
  loading: PropTypes.oneOf(['lazy', 'eager', 'auto']),
}

ImageGatsby.defaultProps = {
  className: null,
  loading: 'lazy',
}

ImageGatsby = chainDecorators(decorators, ImageGatsby)

export default ImageGatsby
